import Swiper, { Navigation } from '../../assets/js/partials/swiper.min';
import { Modal } from '../../assets/js/partials/modal';

Swiper.use([Navigation]);

class TeamBlock {
  constructor() {
    this.slider = null;
    this.sliderTeamClass = '.swiper-team';
    this.descriptionCardClass = '.team__card-description';
    this.sliderClassList = ['one', 'two', 'three'];
    this.sliderPerViewSettings = {
      one: 1,
      two: 2,
      three: 3,
    };

    this.sliderTeam = document.querySelectorAll(this.sliderTeamClass);
    this.descriptionCards = document.querySelectorAll(this.descriptionCardClass);
  }

  init() {
    if (this.descriptionCards.length) {
      this.hideMoreDescription();
    }

    this.initSliders();

    window.addEventListener('resize', () => {
      this.initSliders();
    });
  }

  hideMoreDescription() {
    this.descriptionCards.forEach((item) => {
      let hasMore = false;
      const pElements = item.querySelectorAll('p');
      pElements.forEach((node) => {
        if (node.innerHTML === '<!--more-->') {
          hasMore = true;
        }

        if (hasMore) {
          item.removeChild(node);
        }
      });
    });
  }

  initSliders() {
    this.sliderTeam.forEach((item) => {
      this.createSlider(item);
    });
  }

  createSlider(item) {
    const key = item.getAttribute('data-key');
    const type = this.sliderClassList.find((type) =>
      item.children[0].classList.contains('team__card__container_' + type),
    );
    const sliderPerViewMiddle = this.sliderPerViewSettings[type] === 1 ? 1 : 2;

    this.swiper = new Swiper('.swiper-key-' + key, {
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
        },
        768: {
          slidesPerView: sliderPerViewMiddle,
          spaceBetween: 15,
          loop: true,
        },
        1199: {
          slidesPerView: this.sliderPerViewSettings[type],
          spaceBetween: 30,
          grid: {
            rows: 2,
          },
        },
      },
      navigation: {
        nextEl: '.swiper-team-button-next-' + key,
        prevEl: '.swiper-team-button-prev-' + key,
      },
    });
  }
}

const modal = new TeamBlock();
modal.init();
new Modal('g-modal-team').init();
